import React from 'react'

const DashboardOrganization = () => {
  return (
    <div>DashboardOrganization</div>
  )
}

export default DashboardOrganization